import { CommonModule } from '@angular/common';
import { NgModule, Pipe, PipeTransform } from '@angular/core';
import { Variable } from '@mtna/pojo-consumer-ts';
import { VariableSummary } from '@mtna/variable-service-core-ts';

import { RdsFilterType } from '../models/filter/filter-type.model';
import { RdsFilterUtil } from '../utils';

/**
 * Determine the appropraite filter type given a variable
 */
@Pipe({
  name: 'rdsVariableFilterType',
})
export class RdsVariableFilterTypePipe implements PipeTransform {
  transform(variable: Variable | VariableSummary): RdsFilterType | null {
    return RdsFilterUtil.determineType(variable);
  }
}

@NgModule({
  imports: [CommonModule],
  exports: [RdsVariableFilterTypePipe],
  declarations: [RdsVariableFilterTypePipe],
})
export class RdsVariableFilterTypePipeModule {}
